import UpdateEndTime from './UpdateEndTime';

const SELECTOR = '[data-book-service-form]';
const ADD_ITEM_SELECTOR = "a[data-association='checkout_item']";
const SERVICES_SELECT_SELECTOR = 'select[data-services-select]';
const ITEMS_CONTAINER_SELECTOR = '[data-checkout-items]';
const RECURRING_FREQUENCY_SELECTOR = 'select[data-frequency-select]';

class CheckoutController {
  constructor() {
    this.container = $(SELECTOR);
    if (this.container.length == 0) {
      return false;
    }
    this.sortItems();

    $(ADD_ITEM_SELECTOR)
      .data('association-insertion-method', 'append')
      .data('association-insertion-node', ITEMS_CONTAINER_SELECTOR);

    $('body').on('cocoon:after-insert', (event, $addedTask) => {
      $($addedTask)
        .find(SERVICES_SELECT_SELECTOR)
        .trigger('change');
      $($addedTask)
        .find(RECURRING_FREQUENCY_SELECTOR)
        .trigger('change');
    });

    this.container.on('change', SERVICES_SELECT_SELECTOR, event => {
      this.setMinimumQuantity(event.target);
      new UpdateEndTime();
    });

    this.container.on('click', '.nested-fields__actions a.add-item', event => {
      $(ADD_ITEM_SELECTOR).click();
    });

    this.container.on('change', RECURRING_FREQUENCY_SELECTOR, event => {
      if ($(event.target).val()) {
        $(event.target)
          .closest('.checkout-item')
          .find('.recurring-end-date')
          .show();
      } else {
        $(event.target)
          .closest('.checkout-item')
          .find('.recurring-end-date')
          .hide();
      }
    });
  }

  setMinimumQuantity(element) {
    let min_quantity = $(element)
      .find('option:selected')
      .data('minimum-booking');
    let quantity = $(element)
      .closest('.checkout-item')
      .find('input[data-quantity]');
    if (quantity.val() < min_quantity) {
      quantity.val(min_quantity);
    }
  }

  sortItems() {
    let checkoutItems = this.container.find(ITEMS_CONTAINER_SELECTOR);
    checkoutItems
      .children('.checkout-item')
      .sort(function(a, b) {
        let b_id = $(b).find('[data-quantity]')[0].id;
        let a_id = $(a).find('[data-quantity]')[0].id;
        if (checkoutItems.find('input[name*="][id]"]').length > 0) {
          return b_id.localeCompare(a_id);
        } else {
          return a_id.localeCompare(b_id);
        }
      })
      .appendTo(checkoutItems);
  }
}

export default CheckoutController;



// WEBPACK FOOTER //
// ./src/javascripts/CheckoutController.js